import React, { useEffect } from 'react';
import './App.css';
import { Design } from '../design/Design';
import messageListener from 'src/services/message-listener/message-listener.service';
import refreshTokenService from 'src/services/refresh-token/refresh-token.service';
import { useAppDispatch, useAppSelector } from 'src/hooks/hooks';
import { sendGetContext } from 'src/services/event-message/event-message.service';
import { selectAccessToken, selectSession } from 'src/store/session/sessionSelects';
import { Loader, LoaderSize } from 'src/components/loader/Loader';
import { selectIsLoadingShow } from 'src/store/loader/loaderSelects';
import metricsService, { DISPLAY_DESIGN } from 'src/services/metrics/metrics.service';

function App() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const init = async () => {
            metricsService.setDimensionInfo(DISPLAY_DESIGN);
            await messageListener.init(dispatch);
            sendGetContext();
        };

        init();
    }, []);
    const isLoadingShow = useAppSelector(selectIsLoadingShow);
    const isLoadedContext = useAppSelector(selectAccessToken);
    const session = useAppSelector(selectSession);
    useEffect(() => {
        if (session.accessToken) {
            refreshTokenService.init(dispatch, session);
        }
    }, [session]);

    const design = () => {
        return (
            <div
                data-testid="design-container"
                className={isLoadingShow ? 'container hide' : 'container'}>
                {<Design />}
            </div>
        );
    };

    return (
        <div className="container">
            <Loader
                id="e3dv_loader"
                show={isLoadingShow}
                size={LoaderSize.medium}
                className="loader"
            />
            {isLoadedContext && design()}
        </div>
    );
}

export default App;
